import { queryOptions } from '@tanstack/react-query';
import api from '../services/api';

/**
 * Represents a schema (tenant/organization) that a user has access to.
 */
export interface Schema {
  /** Unique identifier code for the schema (e.g., "demo1", "myosh365") */
  code: string;
  /** Human-readable display name for the schema */
  name: string;
  subscriptionTier?: string | null;
}

/**
 * Response from the /schemas/details API endpoint.
 */
export interface GetSchemasResponse {
  /**
   * List of schemas the user has access to.
   * May be undefined if the API returns an empty or malformed response.
   * An empty array indicates the user has no schema access.
   */
  result?: Schema[];
}

/**
 * Gets all available schemas for a user
 */
export const getSchemas = async (idToken: string) => {
  return api<GetSchemasResponse>('schemas/details', { headers: { authorization: `Bearer ${idToken}` } });
};

export const schemasQueryOptions = (idToken: string) =>
  queryOptions({
    queryKey: ['login-schemas'],
    queryFn: () => getSchemas(idToken),
  });
